enum searchTestIds {
	searchResultsActions = 'search_results_actions',
	searchLoadMoreTryAgain = 'search_load_more_try_again',
	searchResultsCount = 'search_results_count',
	addClientGroupLink = 'add_client_group',
	createReportLink = 'create_report',
	downloadDataLink = 'download_data',
	tableBodyTest = 'tableBodyTest',
	loadMoreResultsLink = 'load_more_results',
	searchResultGridHeader = 'search_results_grid_header',
	clientCheckboxAll = 'client_checkbox_all',
	clientDetails = 'client_details',
	clientAddress = 'client_address',
	clientTotalBalance = 'client_total_balance',
	clientAnnualPremium = 'client_annual_premium',
	clientName = 'client_name',
	clientNumber = 'client_number',
	clientType = 'client_type',
	noResultsContainer = 'noResultsContainer',
}

export default searchTestIds;
